"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPassword = exports.forgotPassword = exports.resendEmail = exports.registerUser = exports.selectIsResetPassword = exports.selectErrors = exports.selectRegistrationLoading = exports.resetPasswordFailure = exports.resetPasswordSuccess = exports.fetchingResetPassword = exports.sendEmailSuccess = exports.resendEmailFailed = exports.setErrors = exports.registerFailed = exports.registerSuccess = exports.registerAttempt = exports.registerSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var auth = __importStar(require("../../helpers/auth"));
exports.registerSlice = toolkit_1.createSlice({
    name: 'register',
    initialState: {
        resendEmail: false,
        loading: false,
        errors: [],
        isResetPassword: false,
    },
    reducers: {
        registerAttempt: function (state) {
            state.loading = true;
            state.errors = [];
        },
        registerSuccess: function (state) {
            state.loading = false;
        },
        registerFailed: function (state) {
            state.loading = false;
        },
        resendEmailFailed: function (state) {
            state.loading = false;
        },
        sendEmailSuccess: function (state) {
            state.loading = false;
        },
        setErrors: function (state, action) {
            state.errors = action.payload;
        },
        fetchingResetPassword: function (state) {
            state.loading = true;
            state.isResetPassword = false;
        },
        resetPasswordSuccess: function (state) {
            state.loading = false;
            state.isResetPassword = true;
        },
        resetPasswordFailure: function (state) {
            state.loading = false;
            state.isResetPassword = false;
        },
    },
});
exports.registerAttempt = (_a = exports.registerSlice.actions, _a.registerAttempt), exports.registerSuccess = _a.registerSuccess, exports.registerFailed = _a.registerFailed, exports.setErrors = _a.setErrors, exports.resendEmailFailed = _a.resendEmailFailed, exports.sendEmailSuccess = _a.sendEmailSuccess, exports.fetchingResetPassword = _a.fetchingResetPassword, exports.resetPasswordSuccess = _a.resetPasswordSuccess, exports.resetPasswordFailure = _a.resetPasswordFailure;
var selectRegistrationLoading = function (state) {
    return state.registration.loading;
};
exports.selectRegistrationLoading = selectRegistrationLoading;
var selectErrors = function (state) { return state.registration.errors; };
exports.selectErrors = selectErrors;
var selectIsResetPassword = function (state) {
    return state.registration.isResetPassword;
};
exports.selectIsResetPassword = selectIsResetPassword;
var registerUser = function (formValues) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.registerAttempt());
                    return [4 /*yield*/, axios_1.default.post('/api/register', formValues)];
                case 1:
                    response = _a.sent();
                    dispatch(exports.registerSuccess());
                    auth.setUnverifiedEmail(formValues.email);
                    return [2 /*return*/, response.data];
                case 2:
                    e_1 = _a.sent();
                    dispatch(exports.setErrors(e_1.response.data.errors));
                    dispatch(exports.registerFailed());
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.registerUser = registerUser;
var resendEmail = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.registerAttempt());
                    return [4 /*yield*/, axios_1.default.post('/api/register/resend-email', {
                            email: auth.getUnverifiedEmail(),
                        })];
                case 1:
                    response = _a.sent();
                    dispatch(exports.sendEmailSuccess());
                    return [2 /*return*/, response.status];
                case 2:
                    e_2 = _a.sent();
                    dispatch(exports.setErrors(e_2.response.data.errors));
                    dispatch(exports.resendEmailFailed());
                    throw e_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.resendEmail = resendEmail;
var forgotPassword = function (formValues) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.registerAttempt());
                    return [4 /*yield*/, axios_1.default.post('/api/forgot-password', formValues)];
                case 1:
                    response = _a.sent();
                    dispatch(exports.sendEmailSuccess());
                    return [2 /*return*/, response.data];
                case 2:
                    e_3 = _a.sent();
                    dispatch(exports.setErrors(e_3.response.data.errors));
                    dispatch(exports.registerFailed());
                    throw e_3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.forgotPassword = forgotPassword;
var resetPassword = function (formValues) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingResetPassword());
                    return [4 /*yield*/, axios_1.default.post('/api/reset-password', formValues)];
                case 1:
                    response = _a.sent();
                    dispatch(exports.resetPasswordSuccess());
                    return [2 /*return*/, response.data];
                case 2:
                    e_4 = _a.sent();
                    dispatch(exports.setErrors(e_4.response.data.errors));
                    dispatch(exports.resetPasswordFailure());
                    throw e_4;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.resetPassword = resetPassword;
exports.default = exports.registerSlice.reducer;
